import React from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomTabset from "../Components/CustomTabset/CustomTabset.jsx";
import {globals} from "../Components/Globals/Globals.js";
import {loadVideos} from "../redux/videoSlice.js";
import { Button } from "reactstrap";

// reactstrap components
import {Container, Row} from "reactstrap";

// core components
import VideosRawTableDataSync from "../Components/VideosRawTableDataSync/VideosRawTableDataSync.jsx"

const AdminVideoView = (props) => {
  const dispatch = useDispatch();

  // Get the stats from the store
  const {videosItems, loadVideos_result} = useSelector((state) => state.video)
  
  React.useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    let isMounted = true

    // If status is !loading, then fetch stats data from the API
    if (loadVideos_result.status === 'idle'){
      if (globals.parameters.redux_debugging) alert("loading videos")
      dispatch(loadVideos());
    }

    if (loadVideos_result.status === 'loading'){
      if (globals.parameters.redux_debugging) alert("loading videos...")
    }

    // If status is !loading, then fetch stats data from the API
    if (loadVideos_result.status === 'succeeded'){
      if (globals.parameters.redux_debugging) alert("videos successfully loaded")
        console.log("AdminVideosView -> videosItems ", videosItems)
    }

    // Cleanup function
    return () => {
      isMounted = false
    }
  }, [loadVideos_result, dispatch]);


  return (    
        <div className="wrapper">
          <div className="main">
            <div className="section">
              <Container>
                {/** Search toolbar */}
                <CustomTabset activeTabset={"video"}/>
                <Row>
                  <div>
                      {videosItems  &&
                      <VideosRawTableDataSync
                        videos_list = {videosItems}
                        table = {true}
                        />}                 
                </div>
                </Row> 
              </Container>
            </div>
          </div>
        </div>
  );
}

export default AdminVideoView;
